var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2.4257C2 2.04758 2.14048 1.68495 2.39053 1.41758C2.64058 1.15021 2.97971 1 3.33333 1H16.6667C17.0203 1 17.3595 1.15021 17.6095 1.41758C17.8595 1.68495 18 2.04758 18 2.4257V4.40836C17.9999 4.91248 17.8125 5.39591 17.4791 5.75232L12.6667 10.8982V17.9544C12.6667 18.1326 12.6241 18.3079 12.5429 18.4636C12.4618 18.6193 12.3447 18.7501 12.203 18.8438C12.0612 18.9375 11.8993 18.991 11.7328 18.9989C11.5663 19.0069 11.4006 18.9694 11.2515 18.8896L7.94755 17.1237C7.763 17.025 7.60778 16.8733 7.4993 16.6856C7.39081 16.498 7.33334 16.2816 7.33333 16.061V10.8982L2.52089 5.75232C2.18747 5.39591 2.0001 4.91248 2 4.40836V2.4257ZM3.77778 2.90092V4.40836L8.72 9.69293C8.84396 9.8253 8.94229 9.9825 9.00941 10.1555C9.07651 10.3286 9.11107 10.514 9.11111 10.7014V15.62L10.8889 16.5705V10.7014C10.8889 10.3231 11.0293 9.96001 11.28 9.69388L16.2222 4.40741V2.90092H3.77778Z",
    fill: "#222B45"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.d77f0673e387a316b9ec9e16a0fb81bf.svg";
export { ForwardRef as ReactComponent };